/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Component for UserBadge
 */

import _ from 'lodash';
import { Tag, Typography } from 'antd';

import { USER_ROLES_META } from 'configs/index';
import { getUserRole } from 'utils/app';

/**
 * interface for props
 */
interface IRoleBadgeProps {
	role: UserManagement.IRoleName;
	mode?: 'tag' | 'indicator';
}

/**
 * find user role in roles list
 */
const findUserRole = (roles: UserManagement.IUserRoleResponse[]): UserManagement.IRoleName | undefined => {
	const assignedRoles = _.map(
		_.filter(roles, ({ assigned }) => assigned),
		({ name }) => name as UserManagement.IRoleName,
	);
	return getUserRole(assignedRoles);
};

/**
 * Component for UserBadge
 * @param {IRoleBadgeProps} props props
 * @returns {React.FC} UserBadge
 */
const RoleBadge: React.FC<IRoleBadgeProps> = ({ role, mode }) => {
	const roleMeta = _.get(USER_ROLES_META, role);
	if (!roleMeta) {
		return null;
	}

	const { title, color, hexCode } = roleMeta;

	if (mode === 'tag') {
		return <Tag color={color}>{title}</Tag>;
	}
	if (mode === 'indicator') {
		return <Typography.Text style={{ color: hexCode }}>{title}</Typography.Text>;
	}
	return <span>{title}</span>;
};

export { RoleBadge, findUserRole };
